import { useContext, type ComponentProps } from "react";
import { Command as CommandPrimitive } from "cmdk";

import { cn } from "../../lib/utils";
import { SelectCollectingContext } from "./SelectContext";

export type SelectSeparatorProps = ComponentProps<typeof CommandPrimitive.Separator>;

export const SelectSeparator = ({ className, ...props }: SelectSeparatorProps) => {
  const collecting = useContext(SelectCollectingContext);
  if (collecting) return null;

  return (
    <CommandPrimitive.Separator
      data-slot="select-separator"
      className={cn("pointer-events-none -mx-1 my-1 h-px bg-border", className)}
      {...props}
    />
  );
};
